import { Component } from "@angular/core";
import { FabButtonService } from "src/app/services/fab-button.service";

@Component({
  selector: "app-fab-container",
  templateUrl: "./fab-container.component.html",
})
export class FabContainerComponent {

   buttons: { backgroundClass?: string, iconClass?: string, title: string, action: () => void }[] = [];

   constructor(fabButtonService: FabButtonService) {
      fabButtonService.buttons$.subscribe((buttons) => {
          this.buttons = buttons;
      });
   }

}
